import type { ReactNode, Ref } from "react";

type Content = { children: ReactNode; className?: string };
const classes = (base: string, extra?: string) => `${base}${extra ? ` ${extra}` : ""}`;

export function DocumentPage({ children, className, label, pageRef, shared = true, contextualActive }: Content & { label: string; pageRef?: Ref<HTMLElement>; shared?: boolean; contextualActive?: boolean }) {
  return <article ref={pageRef} data-contextual-active={contextualActive ? "true" : undefined} className={classes(`${shared ? "document-page " : ""}paper-region invoice-paper invoice-document`, className)} aria-label={label}>{children}</article>;
}
export function DocumentCommandBar({ children, className, shared = true }: Content & { shared?: boolean }) {
  return <header className={classes(`${shared ? "document-command-bar " : ""}invoice-editor-commandbar`, className)}>{children}</header>;
}
export function DocumentMetaGrid({ children, className }: Content) {
  return <dl className={classes("document-meta-grid invoice-document-meta", className)}>{children}</dl>;
}
export function DocumentMetaField({ label, children }: { label: string; children: ReactNode }) {
  return <div className="document-meta-field"><dt>{label}</dt><dd>{children}</dd></div>;
}
export function DocumentParties({ children, className, label }: Content & { label: string }) {
  return <section className={classes("document-parties invoice-facts", className)} aria-label={label}>{children}</section>;
}
export function DocumentLineItems({ children, className }: Content) {
  return <section className={classes("document-line-items invoice-lines", className)}>{children}</section>;
}
export function DocumentAddLine({ onAdd }: { onAdd(): void }) {
  return <button type="button" className="document-add-line" onClick={onAdd}><svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" aria-hidden="true"><path d="M8 3.5v9M3.5 8h9"/></svg>Add a line</button>;
}
export function DocumentTotals({ children, className, label }: Content & { label: string }) {
  return <section className={classes("document-totals invoice-totals", className)} aria-label={label}>{children}</section>;
}
export function DocumentNotes({ children, className }: Content) {
  return <section className={classes("document-notes invoice-note", className)}>{children}</section>;
}
export function DocumentFooter({ issuerName, page, total }: { issuerName: string; page: number; total: number }) {
  return <div className="document-page-footer invoice-document-bottom"><span>{issuerName}</span><span>Page {page} of {total}</span></div>;
}
export function DocumentPickerTarget({ children, label, expanded, targetRef, onToggle, className }: {
  children: ReactNode; label: string; expanded: boolean; targetRef?: Ref<HTMLSpanElement>; onToggle(keyboard?: boolean): void; className?: string;
}) {
  return <span ref={targetRef} data-edit-target data-document-picker role="button" tabIndex={0} className={className} aria-label={label} aria-haspopup="dialog" aria-expanded={expanded} onClick={() => onToggle(false)} onKeyDown={event => {
    if (["Enter", " ", "ArrowDown"].includes(event.key)) { event.preventDefault(); onToggle(true); }
  }}>{children}</span>;
}
